import React, { useState } from 'react';
import './Login.css'
import { Link, useHistory } from "react-router-dom";
import { auth, provider } from "./firebase";

function Login() {
    const history = useHistory();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
//sign in
    const signIn = e => {
        e.preventDefault();

        auth
            .signInWithEmailAndPassword(email, password)
            .then(auth => {
                history.push('/dashboard')
            })
            .catch(error => alert(error.message))
    }

    const register = e => {
        e.preventDefault();

        auth
            .createUserWithEmailAndPassword(email, password)
            .then((auth) => {
                // it successfully created a new user with email and password
                if (auth) {
                    history.push('/dashboard')
                }
            })
            .catch(error => alert(error.message))
    }


    //sign in google
    const signIngoogle = e => {
        e.preventDefault();

        auth
        .signInWithPopup(provider)
            .then(auth => {
                history.push('/dashboard')
            })
            .catch(error => alert(error.message))
    }

    const registergoogle = e => {
        e.preventDefault();

        auth
            .createUserWithPopup(provider)
            .then((auth) => {
                // it successfully created a new user with email and password
                if (auth) {
                    history.push('/dashboard')
                }
            })
            .catch(error => alert(error.message))
    }
    return (
        <div className='login'>
           

            <div className='login__container'>
            <h2 className="signin__title">7 Cities Appliance</h2>
            <h3>Login to Get Started on your road to repair</h3>
            <Link to='/'>
                <img
                    className="login__logo"
                    src='https://i.imgur.com/7n4WMog.gif' 
                />
            </Link>
                <h1 className="signin__title">Sign-in</h1>

                <form>
                    <h5>E-mail</h5>
                    <input type='text' value={email} onChange={e => setEmail(e.target.value)} />

                    <h5>Password</h5>
                    <input type='password' value={password} onChange={e => setPassword(e.target.value)} />

                    <button type='submit' onClick={signIn} className='login__signInButton'>Sign In</button>
                </form>

               

                <button onClick={register} className='login__registerButton'>Create New Account</button>
                <div >
            <div >
           
            </div>
            <button className="google__logo" type="submit" onClick={signIngoogle}> <img  src="https://i.imgur.com/tz4NPBi.png" /></button>
            <p>
                    By signing in you agree to our terms. Thank you for using 7 Cities Appliance
                </p>
                <a href="/">terms and conditions</a>
            </div>
            
           
        </div>
        </div>
    )
}

export default Login
